import { ThemeProvider } from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import { ThemeProvider as ThemeProviderNative } from "@rentiohq/shared-frontend/dist/components/theme/styled-components.native";
import rentioTheme, {
  rentioThemeNative,
} from "@rentiohq/shared-frontend/dist/components/theme/theme.rentio";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { EProduct } from "@rentiohq/shared-frontend/dist/config/app.config.types";
import logger from "@rentiohq/shared-frontend/dist/logger";
import consoleLogger from "@rentiohq/shared-frontend/dist/logger/loggers/logger.console";
import sentryLogger from "@rentiohq/shared-frontend/dist/logger/loggers/logger.sentry";
import { ToastContainer } from "@rentiohq/shared-frontend/dist/managers/Toast";
import RequirementsProvider from "@rentiohq/shared-frontend/dist/providers/RequirementsProvider";
import { setLocale } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { setStore } from "@rentiohq/shared-frontend/dist/utils/redux/redux.utils";
import * as Sentry from "@sentry/browser";
import AppRouter from "AppRouter";
import Page from "components/Page";
import DatePickerProvider from "providers/DatePickerProvider";
import I18nProvider from "providers/I18nProvider";
import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import store from "redux/store";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: CONFIG.SENTRY[EProduct.Pay],
    environment: CONFIG.ENVIRONMENT,
    release: CONFIG.SENTRY_RELEASE,
  });
  logger.registerLogger(sentryLogger);
}

if (process.env.NODE_ENV === "development") {
  logger.registerLogger(consoleLogger);
}

setLocale(navigator.language);
setStore(store);

class App extends React.Component {
  // Render
  public render() {
    return (
      <ReduxProvider store={store}>
        <ThemeProvider theme={rentioTheme}>
          <ThemeProviderNative theme={rentioThemeNative}>
            <ToastContainer />
            <PersistGate
              // @ts-ignore
              persistor={persistStore(store)}
              loading={<Page withScroll={false} />}
            >
              <DatePickerProvider>
                <I18nProvider>
                  <RequirementsProvider>
                    <AppRouter />
                  </RequirementsProvider>
                </I18nProvider>
              </DatePickerProvider>
            </PersistGate>
          </ThemeProviderNative>
        </ThemeProvider>
      </ReduxProvider>
    );
  }
}

// eslint-disable-next-line import/no-default-export
export default App;
